module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/amount-declined/amount-declined.component.css
// module id = ./src/app/components/amount-declined/amount-declined.component.css
// module chunks = main